/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkSlotResultDto = {
    /**
     * Local calendar date of the slot (YYYY-MM-DD)
     */
    date: string;
    /**
     * Slot start (UTC ISO-8601)
     */
    startTime: string;
    /**
     * Slot end (UTC ISO-8601)
     */
    endTime: string;
    /**
     * Whether the slot was created (confirm) or is creatable (dryRun preview).
     */
    ok: boolean;
    /**
     * Why the slot was skipped (present only when ok is false).
     */
    reason?: BulkSlotResultDto.reason;
    /**
     * Created availability window UUID (present only on a confirm when ok is true).
     */
    slotId?: string;
    /**
     * Supported session modes for this slot
     */
    modes: Array<'online' | 'client_location' | 'expert_location'>;
};
export namespace BulkSlotResultDto {
    /**
     * Why the slot was skipped (present only when ok is false).
     */
    export enum reason {
        BLOCKED_DATE = 'blocked_date',
        SLOT_OVERLAP = 'slot_overlap',
        SESSION_OVERLAP = 'session_overlap',
        MAX_SESSIONS_EXCEEDED = 'max_sessions_exceeded',
        DUPLICATE = 'duplicate',
        PAST = 'past',
        INVALID = 'invalid',
    }
}

